<template>
  <div>
    <div class="recipient-container">
      <div class="recipient-properties">
        <transition name="fade" mode="out-in">
          <div class="recipient" v-if="!isEditing" key="full_recipient">
            <div>
              <p>{{ recipient.name }}</p>
              <p>{{ recipient.address }}</p>
              <p v-if="recipient.addressOptional">
                {{ recipient.addressOptional }}
              </p>
              <p>{{ recipient.postalCode }}</p>
              <p>{{ recipient.city }}</p>
              <p>{{ recipient.country }}</p>
            </div>
            <div
              class="payment-slip"
              v-if="paymentSlip && recipient.type === 'paymentSlips'"
            >
              <p>{{ recipient.countryCode }}</p>
              <p>{{ recipient.giroType }}</p>
              <p>{{ recipient.giroNumber }}</p>
              <p>{{ recipient.receiver }}</p>
              <p>{{ priceFormatter(recipient.sum) }} SEK</p>
              <p v-if="recipient.sum">{{ recipient.ocr }}</p>
            </div>
          </div>
          <p class="bold" v-else key="editing_recipient">
            {{ $t('W2P_RECIPIENTS_EDIT_RECIPIENT') }}
          </p>
        </transition>
        <div class="recipient-actions">
          <button
            @click.prevent="
              TOGGLE_EDITING_RECIPIENT({
                index: index,
                value: !isEditing
              })
            "
          >
            <pn-icon
              :symbol="isEditing ? 'close' : 'edit2'"
              color="blue700"
              size="small"
              solid
            ></pn-icon>
            {{ isEditing ? $t('CANCEL') : $t('EDIT') }}
          </button>
          <button @click.prevent="DELETE_RECIPIENT(index)">
            <pn-icon
              symbol="trash-can"
              color="warning"
              size="small"
              solid
            ></pn-icon>
          </button>
        </div>
      </div>
      <transition name="fade">
        <recipient-form
          v-if="isEditing"
          :prePopulate="recipient"
          :index="index"
        />
      </transition>
    </div>
  </div>
</template>

<script>
import RecipientForm from '@/components/letter/address/recipients/RecipientForm'
import { priceFormatter } from '@/helpers/priceFormatter'
import { mapMutations, mapState } from 'vuex'

export default {
  props: {
    recipient: {
      required: true,
      type: Object
    },
    index: {
      required: true,
      type: Number
    }
  },
  components: {
    RecipientForm
  },
  computed: {
    ...mapState(['lang']),
    ...mapState('letter/upload', ['letterOptions']),
    paymentSlip() {
      return this.letterOptions.includePaymentSlip
    },
    isEditing() {
      return this.recipient.isEditing
    }
  },
  methods: {
    ...mapMutations('letter/recipient', [
      'DELETE_RECIPIENT',
      'EDIT_RECIPIENT',
      'TOGGLE_EDITING_RECIPIENT'
    ]),
    priceFormatter
  }
}
</script>

<style lang="scss" scoped>
.recipient-container {
  border: 1px solid $gray200;
  padding: 1.5em;
  margin-top: 1.5em;
  display: flex;
  flex-direction: column;

  .recipient-properties {
    display: flex;
    justify-content: space-between;
  }

  .recipient-property {
    color: $black;
  }

  .recipient-actions {
    margin-bottom: 1em;
    button {
      border: none;
      font-size: 0.9em;
      color: $blue700;
      background-color: unset;

      :active {
        outline: none;
      }
    }
    button:hover {
      cursor: pointer;
    }
  }

  .payment-slip {
    margin-top: 1em;
  }
}
</style>
